import { ButtonWithIcon as Button } from 'src/components/ButtonWithIcon/ButtonWithIcon';
import styled from '@emotion/styled';

export const ApproveFormWrapper = styled('div', { label: 'ApproveFormWrapper' })`
    display: flex;
`;

export const ButtonWrapper = styled(Button, { label: 'ButtonWrapper' })`
    margin-left: 8px;
`;
